import { JkBaseComponent,SqlOption } from 'jk-service';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-stock-view02',
  standalone: true,
  imports: [],
  templateUrl: './stock-view02.component.html',
  styleUrl: './stock-view02.component.scss'
})
export class StockView02Component extends JkBaseComponent {
  private _stockno: string = '';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  set stockno(stockno:string){
    if(stockno !== ''){
      this._stockno = stockno;
      this.getData(stockno);
    }
  };
  get stockno():string{
    return this._stockno;
  }
  constructor() {
    super();

  }
  override ngOnInit(): void {
    super.ngOnInit();
  }
  getData(stockno: string): void {
    console.log('stockno:', stockno);
    let sqlOpt = new SqlOption();
    sqlOpt.sqlSelect = `SELECT MA019 FROM STKMA
      LEFT JOIN STKTM ON MA001 = TM002

      WHERE MA001 = '${stockno}'`;
    // STKLI 商品財務資料檔-季
  }

}
